import React from 'react';
import PropTypes from 'prop-types';

import TextSwitch from '../TextSwitch';

import styles from './styles.module.css';

const CheckboxGroup = ({
    options, value, onSelect,
}) => {
    const elements = options.map((opt) => (
        <TextSwitch
            {...opt}
            onSelect={onSelect}
            checked={value && value.indexOf(opt.value) > -1}
            key={opt.value}
        />
    ));

    return (
        <div className={styles.container}>
            {elements}
        </div>
    );
};

CheckboxGroup.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
    ).isRequired,
    value: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),
    ),
    onSelect: PropTypes.func.isRequired,
};

CheckboxGroup.defaultProps = {
    value: null,
};

export default CheckboxGroup;
